import { PropertyConfig } from "../../../forms/propertyConfig";
import { RegisterValidator, Validator } from "./validator";

export const requiredValidatorName = "required";
/**
 * This validator ensures a value is set
 * sample use in propertyConfig => validators: validatorEntry(RequiredValidator, true) or validators: { required: true } (second option requires this class to be loaded)
 */
@RegisterValidator(requiredValidatorName)
export class RequiredValidator implements Validator<unknown, boolean> {
    /**
     * @returns true if property value is not null or undefined or empty string
     */
    public isValid(property: PropertyConfig, propertyValue: unknown, validatorParams: boolean, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        return propertyValue != null && propertyValue !== "" && !(Array.isArray(propertyValue) && propertyValue.length === 0);
    }
}